var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { H3 } from 'syf-component-library/ui/typography';
import query from '../../../mediaQueries';
export var Title = styled(H3)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline;\n  color: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 24px;\n  letter-spacing: normal;\n  margin-left: -1px;\n\n  @media ", " {\n    font-size: 14px;\n    text-align: left;\n    line-height: 1.29;\n  }\n"], ["\n  display: inline;\n  color: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 24px;\n  letter-spacing: normal;\n  margin-left: -1px;\n\n  @media ", " {\n    font-size: 14px;\n    text-align: left;\n    line-height: 1.29;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.bodyText;
}, function (_a) {
    var bold = _a.bold;
    return (bold ? 600 : 'normal');
}, query.lessThanSmall);
var templateObject_1;
